// Généré par maquettes/outils/dc2react.py à partir de la maquette. Ne pas modifier à la main :
// changer maquettes/src puis relancer le script.
import React from 'react';

export default function SiteFooter({ v }) {
  return (
    <footer style={{ maxWidth: "1240px", margin: "0 auto", padding: "28px 24px 40px", display: "flex", flexWrap: "wrap", justifyContent: "space-between", gap: "12px 32px", fontSize: "14px", color: "#4A5059" }}>
      <span>
        <strong style={{ color: "#15171A" }}>
          Autoria
        </strong>
        {" · Mattéo, outils sur mesure pour l'e‑commerce"}
      </span>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px 20px" }}>
        <a href="/#equipes" style={{ color: "#4A5059" }}>
          Équipes
        </a>
        <a href="/#offres" style={{ color: "#4A5059" }}>
          Offres
        </a>
        <a href="/reappro-prevision-stock" style={{ color: "#4A5059" }}>
          Réappro
        </a>
        <a href="/marge-par-canal" style={{ color: "#4A5059" }}>
          Marge
        </a>
        <a href="/formation-ia-equipe-ecommerce" style={{ color: "#4A5059" }}>
          Formation
        </a>
        <a href="/outils" style={{ color: "#4A5059" }}>
          Outils gratuits
        </a>
        <a href="/blog" style={{ color: "#4A5059" }}>
          Blog
        </a>
        <a href="/about" style={{ color: "#4A5059" }}>
          À propos
        </a>
        <a href="https://www.malt.fr/profile/matteogalfre" style={{ color: "#4A5059" }}>
          Malt
        </a>
        <a href="https://www.linkedin.com/in/mgalfre/" style={{ color: "#4A5059" }}>
          LinkedIn
        </a>
        <a href="/mentions-legales" style={{ color: "#4A5059" }}>
          Mentions légales
        </a>
        <a href="/mentions-legales#cookies" data-cookies="" style={{ color: "#4A5059" }}>
          Cookies
        </a>
      </div>
    </footer>
  );
}
